import { setAdminUncsModalState } from '@root-gipro/modules/AdminPanel/store/actions'
import { PointElem } from '@root-gipro/modules/userProjects/components/Project/UncAdd/PointElem'
import { ToggleTabs } from '@root-gipro/modules/userProjects/components/Project/UncAdd/ToggleTabs'
import { UncSearch } from '@root-gipro/modules/userProjects/components/Project/UncAdd/UncSearch'
import { itemsTab } from '@root-gipro/modules/userProjects/models/consts/unc-add-tabs.cons'
import {
	changeUncCheckedTable,
	fetchUncTableData,
	selectTableElem,
} from '@root-gipro/modules/userProjects/store/actions'
import { SecondaryBtn } from '@root-gipro/shared/Button/Button'
import { IUncSection, IUncTableElem } from '@root-gipro/store/interfaces'
import { IState } from '@root-gipro/store/interfaces/state'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ScrollArea from 'react-scrollbar'

interface IUncsList {
	solutionCase?: boolean
}

export const UncList: React.FC<IUncsList> = ({ solutionCase }) => {
	const [activeList, setActiveList] = useState<string>(itemsTab[0].value)
	const { uncMains, uncSections } = useSelector((state: IState) => state.public)
	const { uncFilter, uncCheckedTable } = useSelector((state: IState) => state.userProjects)
	const { unc_sort } = useSelector((state: IState) => state.userProjects.projectObj)
	const { isAdminUncsModalState } = useSelector((state: IState) => state.adminPanel)
	const dispatch = useDispatch()

	const cancelHandler = () => {
		dispatch(setAdminUncsModalState({ linkOpen: false, editOpen: false }))
		dispatch(selectTableElem(null))
	}
console.log(uncMains, 'uncMains');

	return (
		<div className={`uncs_list ${solutionCase ? 'admin_side_open' : ''}`}>
			<div className='uncs_list__head flex space-between'>
				<h1>Таблицы расценок УНЦ</h1>
				<UncSearch setActiveList={setActiveList} />
			</div>
			<div className='options'>
				<ToggleTabs items={itemsTab} clickHandler={item => setActiveList(item.value)} />
			</div>
			<ScrollArea speed={0.8} smoothScrolling={true} style={{ height: 557 }}>
				{activeList === itemsTab[0].value ? (
					<>
						{uncSections
							.filter(
								(section: IUncSection) =>
									section.name.toLowerCase().match(uncFilter) || section.num.toString().toLowerCase().match(uncFilter)
							)
							.map((section: IUncSection) => (
								<PointElem
									key={section.num}
									name={section.name}
									num={section.num}
									uncMainIds={section.uncMainIds}
									solutionCase={solutionCase}
								/>
							))}
					</>
				) : (
					<>
						{uncMains.length > 0 &&
							uncMains
								.filter(
									(uncElem: IUncTableElem) =>
										uncElem.name.toLowerCase().match(uncFilter) || uncElem.code.toLowerCase().match(uncFilter)
								)
								.map((uncElem: IUncTableElem) => (
									<div
										onClick={() => {
											dispatch(selectTableElem(uncElem))
											unc_sort && dispatch(fetchUncTableData(uncElem.id, unc_sort))
											solutionCase && dispatch(fetchUncTableData(uncElem.id, '2024'))

											if (uncCheckedTable === 8 && uncElem.code !== 'С1') dispatch(changeUncCheckedTable(1))
										}}
										key={uncElem.id}
										className='point'
									>
										<span className='table_num'>{uncElem.code}. </span>
										{uncElem.name}
									</div>
								))}
					</>
				)}
			</ScrollArea>
			{isAdminUncsModalState ? (
				<div className='action_btns filter_side_btns mt-8'>
					<SecondaryBtn variant='contained' onClick={cancelHandler} className='fullWidth'>
						Закрыть
					</SecondaryBtn>
				</div>
			) : (
				''
			)}
		</div>
	)
}
